import { useFallbackTranslation } from '@gn-audio/jss-components';

const PartnerDetailsLoader = () => {
  const { t } = useFallbackTranslation();

  return (
    <div>
      <div aria-live="polite" role="status" className="sr-only">
        {t('system.Loading')}
      </div>
      <div className="mb-8 h-10 w-3/4 animate-pulse rounded-md bg-gray-200"></div>

      <div className="mb-4">
        <div className="mb-2 h-6 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
      </div>
      <div className="mb-4">
        <div className="mb-2 h-6 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="mb-1 h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="mb-1 h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="mb-1 h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
      </div>
      <div className="mb-4">
        <div className="mb-2 h-6 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
      </div>
      <div className="mb-4">
        <div className="mb-2 h-6 w-56 animate-pulse rounded-md bg-gray-200"></div>
        <div className="h-4 w-56 animate-pulse rounded-md bg-gray-200"></div>
      </div>
    </div>
  );
};

export default PartnerDetailsLoader;
